import { reverse } from 'named-urls'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import type { TableData } from '@fourthwall/components'
import { EmptyState, List, Table, useMediaQueryContext } from '@fourthwall/components'
import type { GiveawayPackage } from '@fourthwall/services/dist/GiftsApiClient'
import type { LocationState } from '@types'
import { routing } from '@utils/routing'

import { GiveawayPackageListItem } from '../GiveawayPackageListItem/GiveawayPackageListItem'
import { TABLE_HEADERS } from './consts'

const getGiveawayPackageLink = (row: any, locationState: LocationState) => {
  const giveawayPackageId = row.packageId

  return {
    pathname: reverse(routing.promotions.giveawayPackages.giveawayPackage.self, {
      giveawayPackageId,
    }),
    search: location.search,
    state: locationState,
  }
}

export type GiveawayPackagesTableProps = {
  data: TableData<GiveawayPackage>[]
  isLoading: boolean
}

export const GiveawayPackagesData = ({ data, isLoading }: GiveawayPackagesTableProps) => {
  const media = useMediaQueryContext()
  const location = useLocation()

  const locationState: LocationState = {
    from: { label: 'Promotions', location },
  }

  const emptyComponent = (
    <EmptyState
      title="You haven't created any giveaway links yet."
      subtitle="Giveaway links let recipients easily redeem free products from your store."
      label="Create giveaway link"
      to={routing.promotions.giveawayPackages.create.self}
    />
  )

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        getItemLink={(giveawayPackage) => getGiveawayPackageLink(giveawayPackage, locationState)}
        renderItem={(givewayPackage: GiveawayPackage) => (
          <GiveawayPackageListItem giveawayPackage={givewayPackage} />
        )}
        emptyComponent={emptyComponent}
        locationState={locationState}
      />
    )
  }

  return (
    <Table
      data={data}
      headers={TABLE_HEADERS}
      isLoading={isLoading}
      rowComponent={Link}
      emptyComponent={emptyComponent}
      getRowLink={(giveawayPackage) => getGiveawayPackageLink(giveawayPackage, locationState)}
    />
  )
}
